const buyNowSelector = '[data-nookwise-buy-now]';

async function handleBuyNow(button) {
  if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

  const form = button.closest('form');
  if (!form) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = button.dataset.loadingText || 'Loading…';

  try {
    const formData = new FormData(form);
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'Unable to add this item to the cart.');
    }

    window.location.assign(`${root}checkout`);
  } catch (error) {
    console.error('[Nookwise Buy Now]', error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = originalText;

    const liveRegion = form.closest('product-form-component')?.querySelector('[ref="liveRegion"]');
    if (liveRegion) {
      liveRegion.textContent = error.message || 'Something went wrong. Please try again.';
    }
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(buyNowSelector);
  if (!button) return;
  event.preventDefault();
  handleBuyNow(button);
});


// Makes homepage slideshow banners clickable while preserving links/buttons inside the slide.
document.addEventListener('click', (event) => {
  const slide = event.target.closest('slideshow-slide[data-banner-link]');
  if (!slide) return;
  if (event.target.closest('a, button, input, select, textarea, label')) return;

  const url = slide.dataset.bannerLink;
  if (url) window.location.assign(url);
});
